import { render, staticRenderFns } from "./GroupTiles.vue?vue&type=template&id=05e1aa04&lang=pug"
import script from "./GroupTiles.vue?vue&type=script&lang=js"
export * from "./GroupTiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports